!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("lib", ["react"], t) : "object" == typeof exports ? exports.lib = t(require("react")) : e.lib = t(e.react);
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 2);
  }([function (e, t, n) {
    e.exports = n(3)();
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(1),
      o = n.n(r),
      a = n(0),
      i = n.n(a);
    function u(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var n = [],
          r = !0,
          o = !1,
          a = void 0;
        try {
          for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0);
        } catch (e) {
          o = !0, a = e;
        } finally {
          try {
            r || null == u.return || u.return();
          } finally {
            if (o) throw a;
          }
        }
        return n;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return c(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(n);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return c(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function f(e) {
      return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    var l = !1,
      s = function (e, t) {
        var n = !1,
          r = "" === e.target ? e : e.target;
        if (r.attributes) for (var o = function (e, r, o) {
            "object" === f(t) ? t.findIndex(function (t) {
              return t === r[e].nodeName;
            }) > -1 && (n = !0) : r[e].nodeName === t && (n = !0);
          }, a = 0, i = r.attributes, u = i.length; a < u; a++) o(a, i);
        return n;
      },
      d = function (e) {
        var t = e.ignoreChildrenLinks,
          n = void 0 !== t && t,
          a = e.ignoreBeforeunloadDocument,
          i = void 0 !== a && a,
          c = e.blockRoute,
          f = void 0 === c || c,
          d = e.children,
          p = e.modalComponentHandler,
          y = e.beforeUnload,
          b = e.beforeUnloadSendBeacon,
          m = e.alertMessage,
          v = void 0 === m ? "Are you sure you want to leave? Changes will not be saved." : m,
          g = Object(r.useRef)(),
          h = u(Object(r.useState)(!1), 2),
          S = h[0],
          O = h[1],
          j = u(Object(r.useState)({}), 2),
          E = j[0],
          w = j[1],
          T = function (e) {
            e && e.preventDefault && e.preventDefault(), O(!1);
          },
          x = function (e) {
            var t = E.event.target || E.event.srcElement;
            e && e.preventDefault && e.preventDefault(), O(!1);
            var n = function (e) {
              e.setAttribute("ignoretemp", "true"), e.click();
            };
            return console.log(y), y ? y(function () {
              n(t);
            }) : n(t);
          },
          _ = function (e) {
            if (O(!1), f && !l) return e.preventDefault(), e.returnValue = v, v;
            l = !1;
          },
          B = function (e) {
            if (s(e, "ignoretemp")) !function (e) {
              (e.target || e.srcElement).removeAttribute("ignoreTemp");
            }(e), w({});else if (f && e.target.href !== window.location.href) return e.preventDefault(), s(e, ["custom-ignore", "ignore"]) ? (l = !0, (n = (t = e).target || t.srcElement).setAttribute("ignoretemp", "true"), void n.click()) : (w({
              event: e
            }), O(!0));
            var t, n;
            return !0;
          },
          k = function () {
            return navigator.sendBeacon(b.path, b.data);
          },
          A = p || function () {
            var e = confirm(v);
            O(!1), !0 === e ? x() : T();
          };
        return Object(r.useEffect)(function () {
          return function () {
            var e = document.getElementsByTagName("a");
            if (e) for (var t = 0; t < e.length; t++) s(e[t], "href") && e[t].addEventListener("click", B, !1);
            if (n && g.current) {
              var r = g.current.getElementsByTagName("a");
              if (r) for (var o = 0; o < r.length; o++) r[o].setAttribute("ignore", "true");
            }
            if (i || window.addEventListener("beforeunload", _), b) {
              if (!navigator.sendBeacon) throw "sendBeacon not supported | remove beforeUnloadSendBeacon ";
              window.addEventListener("unload", k);
            }
          }(), function () {
            !function () {
              var e = document.getElementsByTagName("a");
              if (e) for (var t = 0; t < e.length; t++) e[t].removeEventListener("click", B, !1);
              i || window.removeEventListener("beforeunload", _), b && navigator.sendBeacon && window.removeEventListener("unload", k);
            }();
          };
        }), o.a.createElement(o.a.Fragment, null, S ? A({
          handleModalLeave: x,
          handleModalCancel: T
        }) : null, o.a.createElement("span", {
          ref: g
        }, d));
      };
    d.propTypes = {
      ignoreChildrenLinks: i.a.bool,
      blockRoute: i.a.bool,
      ignoreBeforeunloadDocument: i.a.bool,
      children: i.a.any.isRequired,
      alertMessage: i.a.string,
      modalComponentHandler: i.a.any,
      beforeUnload: i.a.func,
      beforeUnloadSendBeacon: i.a.object
    }, t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(4);
    function o() {}
    function a() {}
    a.resetWarningCache = o, e.exports = function () {
      function e(e, t, n, o, a, i) {
        if (i !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }]);
});